import { render } from "./ProductCombo.vue?vue&type=template&id=2cbccd58&scoped=true"
import script from "./ProductCombo.vue?vue&type=script&lang=js"
export * from "./ProductCombo.vue?vue&type=script&lang=js"

import "./ProductCombo.vue?vue&type=style&index=0&id=2cbccd58&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cbccd58"],['__file',"src/views/h5/common/product/info/ProductCombo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2cbccd58"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2cbccd58', __exports__)) {
    api.reload('2cbccd58', __exports__)
  }
  
  module.hot.accept("./ProductCombo.vue?vue&type=template&id=2cbccd58&scoped=true", () => {
    api.rerender('2cbccd58', render)
  })

}


export default __exports__